import React, {useState} from "react";

// import Modal from 'react-modal';


const RenewMember = () => {
// const [modalIsOpen,setModalIsOpen] = useState(false)


    return (
        <>
            <div className="member_cancle">
                <h2 className="text-jost-sb-24">Gain Benefits:</h2>
                <div className="member__cancle-link">

                    <button target="_self" className="res-btn-primary">Renew Membership</button>


                </div>

            </div>



        </>
    );
};
export default RenewMember;